import { ClassicEditor } from '@ckeditor/ckeditor5-editor-classic';


export class RTLHelper {

    public static applyRTLFix(editor: ClassicEditor): void {
        editor.model.document.on('change:data', (event, data) => {
            requestAnimationFrame(() => {
                this.addDirectionAttribute(document.querySelector('.ck-content'));
            });
        });
    }

    public static addDirectionAttribute(element: HTMLElement): void {
        if (!element) {
            return;
        }
        const lists = element.querySelectorAll('ul, ol');
        lists?.forEach((list: HTMLElement) => {
            list.removeAttribute('dir');
            const listItems = (Array.from(list.children) as HTMLElement[]).filter(x => x.tagName !== 'UL' && x.tagName !== 'OL');
            if (listItems.every(x => x.querySelector('[dir="rtl"]') || x.getAttribute('dir')?.toLowerCase() === 'rtl')) {
                list.setAttribute('dir', 'rtl');
                list.style.paddingRight = '40px';
            }
        });
    }
}
